// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"871ed923","316":"99ea8b75","389":"a08f416d","732":"c78583b9","977":"27b45144"}[chunkId] + ".chunk.js");